var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFavorite02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 609 609.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke-width:0px;}.cls-3{clip-path:url(#clippath);}.cls-2{fill:#4289c8;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 609,
    height: 609
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_-_active"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32432",
    className: "cls-2",
    d: "M304.5.09C136.33.09,0,136.42,0,304.59s136.33,304.5,304.5,304.5,304.5-136.33,304.5-304.5S472.67.09,304.5.09M471.79,267.05l-78.16,69.24,22.53,101.95c1.76,7.86-3.19,15.66-11.05,17.42-3.62.81-7.41.21-10.6-1.67l-90.01-53.04-90.01,52.86c-6.94,4.1-15.88,1.79-19.98-5.14-1.88-3.19-2.48-6.98-1.67-10.6l22.56-101.95-78.2-69.15c-6.04-5.33-6.61-14.55-1.28-20.59,2.45-2.78,5.87-4.52,9.57-4.87l103.93-9.99,41.69-95.8c3.2-7.39,11.79-10.79,19.18-7.58,3.4,1.47,6.11,4.18,7.58,7.58l41.72,95.8,103.93,10.05c8.02.76,13.91,7.87,13.15,15.89-.35,3.69-2.09,7.11-4.87,9.57"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavorite02);
export default __webpack_public_path__ + "static/media/icon-favorite-02.843a3a3d405607c843b86d373ca6f2ee.svg";
export { ForwardRef as ReactComponent };